import React, { ReactElement } from "react";
import { Helmet } from "react-helmet";
import pharaohLogo from "../images/pharaoh.jpg";

const DEFAULT_DESCRIPTION = "Earn money by building your empire.";

export interface HtmlHeadProps {
  title: string;
  description?: string;
}

const HtmlHead = ({
  title,
  description = DEFAULT_DESCRIPTION,
}: HtmlHeadProps): ReactElement => (
  <Helmet
    htmlAttributes={{ lang: "en" }}
    title={title}
    meta={[
      { name: "description", content: description },
      {
        name: "viewport",
        content: "width=device-width, initial-scale=1, maximum-scale=1",
      },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:image", content: pharaohLogo },
      { name: "twitter:card", content: "summary" },
      { name: "twitter:site:id", content: "1389683026762764290" },
      { name: "twitter:creator:id", content: "1389683026762764290" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: description },
      { name: "twitter:image", content: pharaohLogo },
    ]}
    link={[
      { href: "https://fonts.gstatic.com", rel: "preconnect" },
      {
        href:
          "https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap",
        rel: "stylesheet",
      },
    ]}
  />
);
export default HtmlHead;
